export const sanitizeInputValue = (value) => {
  let sanitizedValue = value.replace(/[^\x20-\x7E]/g, '');
  return sanitizedValue;
}